import { ReportOption } from 'components/reports/ExperimentReportOptions';
import React from 'react';
import { RMCheckBoxY } from './RMCheckbox';

interface Props {
  label: string;
  isChecked: boolean;
  onChange: (e) => void;
  disabled: boolean;
}
export default function RMCheckboxWithLabel(props: Props) {
  const { label, isChecked, onChange, disabled } = { ...props };
  return (
    <ReportOption
      id={`controls-rmcheckboxwithlabel-reportoption-${label}`}
      data-testid={`controls-rmcheckboxwithlabel-reportoption-${label}`}
      input={
        <RMCheckBoxY isChecked={isChecked} onChange={onChange} disabled={disabled} />
      }
      label={label}
    />
  );
}
